import React from 'react';

import withErrorHandler from '../../hocs/withErrorHandler'
import axios from '../../httpClients/axios-datamerch'

import {
  Grid,
  TextField
} from '@mui/material';

const FeedbackInfo = props => {
  const { 
    onChange,
    //profile,
    formState,
    hasError
  } = props;

  let feedbacktypes = [
    {
      value: '',
      label: ''
    },
    {
      value: 'Question/Support',
      label: 'Question/Support'
    },
    {
      value: 'Comment/Feedback',
      label: 'Comment/Feedback'
    },
    {
      value: 'Bug',
      label: 'Bug'
    }
  ];
  
  return (
    <React.Fragment>
      <Grid
        container
        spacing={3}
      >
        <Grid
          size={{xs:12, md:12}}
        >
          <TextField
            fullWidth
            label="Your Name"
            margin="dense"
            error={hasError('name')}
            name="name"
            onChange={onChange}
            required
            value={formState.values.name || ''}
            variant="outlined"
            type="text"
            helperText={
              hasError('name') ? formState.errors.name[0] : null
            }
          />
        </Grid>
        <Grid
          size={{xs:12, md:12}}
        >
          <TextField
            fullWidth
            label="Email Address"
            margin="dense"
            error={hasError('email')}
            name="email"
            onChange={onChange}
            required
            value={formState.values.email || ''}
            variant="outlined"
            type="text"
            helperText={
              hasError('email') ? formState.errors.email[0] : null
            }
          />
        </Grid>
        <Grid
          size={{xs:12, md:12}}
        >
          <TextField
            fullWidth
            label="Feedback Type"
            margin="dense"
            name="feedbacktype"
            onChange={(event) => onChange(event, 'feedbacktype')}
            required
            select
            SelectProps={{ native: true }}
            value={formState.values.feedbacktype || ''}
            variant="outlined"
            >
            {feedbacktypes.map(option => (
                <option
                    key={option.value}
                    value={option.value}
                >
                    {option.label}
                </option>
            ))}
            </TextField>
        </Grid>
        <Grid
          size={{xs:12, md:12}}
        >
          <TextField
            fullWidth
            label="Subject"
            margin="dense"
            error={hasError('subject')}
            name="subject"
            onChange={onChange}
            required
            value={formState.values.subject || ''}
            variant="outlined"
            type="text"
            helperText={
              hasError('subject') ? formState.errors.subject[0] : null
            }
          />
        </Grid>
        <Grid
          size={{xs:12, md:12}}
        >
          <TextField
            fullWidth
            label="Description"
            margin="dense"
            error={hasError('description')}
            name="description"
            onChange={onChange}
            required
            value={formState.values.description || ''}
            variant="outlined"
            multiline
            rows={4}
            helperText={
              hasError('description') ? formState.errors.description[0] : null
            }
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default withErrorHandler(FeedbackInfo, axios)